export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70e5308802393cc393f53b751d03571958c0f28f9a&name=pushAdClickData!'